import React from 'react';
import PropTypes from 'prop-types';
import './List.css';

import FixedSizeList from './FixedSizeList';
import HeadersFactory from './HeadersFactory';
import Filters from '../../filters/Filters';
import AutomixToggleButton from '../../automix/AutomixToggleButton';
import SaveButton from './SaveButton';

import useOrderBy from '../../../../hooks/useOrderBy';
import useFilters from '../../../../hooks/useFilters';
import useTooltip from '../../tooltip/hooks/useTooltip';

function ListV2({
  id, pathApi = null, data = null, title = null, subTitle = null, width, height, size, style,
  type = `Full#`, orderBy = [], filters = [], isLoadMore = false, sortable = false, enableKeys = false, enableArrows = true, enableShortcuts = false,
  filtersStyle, automix = false, automixStyle, automixName = 'automix', isBoost = false, panelStyle,
  from = '/home', dnd = true,
  titleClassName = '', titleContainerClassName = '', subTitleClassName = '',
  isBaseRootApi = true, customFormatData = null,
  enableSave = false,
  name = null,
  loadMoreWithApi = true
}) {

  const { listOrderBy, getOrderByFormatted, getLocalOrderBy, sortLocalData } = useOrderBy(orderBy, id);
  const { listFilters, getFiltersFormatted, getLocalFilters, onValidFilters, onClearFilters, byFilters } = useFilters(filters);

  // FILTERS / ORDER BY AVAILABLE FOR DATA LOCAL - COMBINING Orderby & Filters
  let prepareData = (data) ? sortLocalData(data).filter(byFilters) : null;
  // FILTERS / ORDER BY AVAILABLE FOR REQUEST API - COMBINING Orderby & Filters
  let preparePathApi = (isBoost && (getLocalFilters() || getLocalOrderBy())) ? `LOCAL|` + getLocalFilters() + getLocalOrderBy() : pathApi + getFiltersFormatted() + getOrderByFormatted();

  const isSortable = (sortable) ? ((!getFiltersFormatted() && !getOrderByFormatted()) ? true : false) : false;

  useTooltip(`ref-list`, `Browser`, `Drag tracks, releases, playlists, DJ charts and DJ sets to playlist directory for management. (left column)  Adjust track order within playlists by dragging up or down. To load tracks in player, drag above to desired deck (automix must be off)`);

  return (
    <div id={`ref-list`} className={`flexColumn`} style={{ ...style, height: height + 26 }}>
      { title && 
        <div className={`flexRow ${titleContainerClassName}`}>
          <span className={`type-title ${titleClassName}`}>
            {title}
            { subTitle && <span className={subTitleClassName}>{subTitle}</span> }
          </span>
        </div>
      }

      { enableSave ? <SaveButton name={automixName} idPlaylist={id} />  : null }

      { automix ? <AutomixToggleButton uid={automixName} idPlaylist={id} style={automixStyle} /> : null }

      { filters.length ? <Filters idPlaylist={id} filters={listFilters} onValid={onValidFilters} height={height} onClear={onClearFilters} style={filtersStyle} panelStyle={panelStyle} /> : null }

      <HeadersFactory type={type} width={width} hasTitle={!!title} orderBy={listOrderBy} />

      <FixedSizeList
        width={width}
        height={height}
        isLoadMore={isLoadMore}
        loadMoreWithApi={loadMoreWithApi}
        pathApi={pathApi ? preparePathApi : null}
        data={prepareData}
        isBaseRootApi={isBaseRootApi}
        customFormatData={customFormatData}
        id={id}
        name={name}
        from={from}
        rowSize={size}
        rowType={type}
        sortable={isSortable}
        enableKeys={enableKeys}
        enableArrows={enableArrows}
        enableShortcuts={enableShortcuts}
        isBoost={isBoost}
        dnd={dnd}
      />
    </div>
  )
}

ListV2.propTypes = {
  id: PropTypes.any.isRequired,
  pathApi: PropTypes.string,
  data: PropTypes.array,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  titleClassName: PropTypes.string,
  subTitleClassName: PropTypes.string,
  titleContainerClassName: PropTypes.string,
  width: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
  size: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  sortable: PropTypes.bool,
  orderBy: PropTypes.array,
  filters: PropTypes.array,
  isLoadMore: PropTypes.bool,
  style: PropTypes.object,
  filtersStyle: PropTypes.object,
  automix: PropTypes.bool,
  from: PropTypes.string,
  isBoost: PropTypes.bool, // to avoid request again
  enableKeys: PropTypes.bool,
  enableArrows: PropTypes.bool,
  dnd: PropTypes.bool,
  isBaseRootApi: PropTypes.bool
}

export default ListV2;
